import { SettingsPermissions } from "@redotech/account-common/permissions";
import type {
  SettingAccess,
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ShippingDiscountsFlatTeamSettingGroupId =
  "shipping_discounts.free_shipping_codes";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason: "Free-shipping discount codes shoppers can redeem at checkout.",
};

// Reaching the page and editing it are two different permissions. The whole
// Shipping settings section — nav entry and every route under it — is gated on
// SET_SHIPPING_SETTINGS, so that is what reading has to demand; the page's own
// edit control gates on SET_ORDER_FULFILLMENT_SETTINGS (see discounts.tsx), so
// that is what writing has to demand.
const groupAccess: SettingAccess = {
  read: {
    minVisibility: "merchant",
    permission: SettingsPermissions.SET_SHIPPING_SETTINGS,
  },
  write: {
    mode: "grants",
    grants: [
      {
        minVisibility: "merchant",
        method: "direct",
        permission: SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
      },
    ],
  },
};

export const ShippingDiscountsFlatTeamSettingGroups = [
  {
    id: "shipping_discounts.free_shipping_codes",
    title: "Free shipping codes",
    description:
      "Discount codes shoppers enter at checkout to receive free shipping, on both domestic and cross-border orders.",
    productArea: "fulfillment",
    access: groupAccess,
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "discounts" },
    synonyms: ["free shipping codes", "shipping discounts"],
  },
] as const satisfies readonly SettingGroupDefinition<ShippingDiscountsFlatTeamSettingGroupId>[];
